import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import banner1 from "../../../assets/images/core.jpg";
import WaterIcon from "@mui/icons-material/Water";
import Container from "../../../common/Container";

function Pathway() {
  return (
    <Box sx={{ flexGrow: 1 }} marginTop={{ xs: "25%", sm: "5%" }}>
      <Box>
        <Box position={"relative"}>
          <Box
            component="img"
            height={{ xs: "110vh", sm: "750px" }}
            display={{ xs: "none", sm: "inline" }}
            sx={{
              objectFit: "cover",
              position: "relative",
              overflow: "hidden",
              width: "100%",
            }}
            src={banner1}
            alt={"core-areas-image"}
          />
          <Container>
            <Box
              paddingBottom={"3%"}
              position={"absolute"}
              top={{ xs: "15%", sm: "20%" }}
              width={{ xs: "90%", sm: "75%" }}
            >
              <Typography
                variant="h6"
                color="#fff"
                fontWeight={700}
                paddingBottom={{ xs: "5%", sm: "2%" }}
                paddingTop={{ xs: "28%", sm: "0%" }}
                textAlign={"left"}
              >
                <Box component={"span"}>
                  <WaterIcon
                    sx={{
                      width: 23,
                      height: 23,
                    }}
                  />
                </Box>{" "}
                Our Innovative Pathway
              </Typography>
              <Typography
                variant="h3"
                color="#fff"
                fontWeight={700}
                paddingBottom={"2%"}
                textAlign={"left"}
                display={{ xs: "none", sm: "block" }}
              >
                Our innovative approach is to develop a forward-thinking
                strategy that transforms Africa’s blue food systems, ensuring
                that no African is deprived of access to fish protein as long as
                there is water in their environment.
              </Typography>
              <Typography
                variant="h4"
                color="#fff"
                fontWeight={700}
                paddingBottom={"2%"}
                textAlign={"left"}
                display={{ xs: "block", sm: "none" }}
              >
                Our innovative approach is to develop a forward-thinking
                strategy that transforms Africa’s blue food systems, ensuring
                that no African is deprived of access to fish protein as long as
                there is water in their environment.
              </Typography>
            </Box>
          </Container>
        </Box>
      </Box>
    </Box>
  );
}

export default Pathway;
